import React, {FC} from 'react'
import {Button, Icon, Stack} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {useAppDispatch} from 'redux/config'
import FiltersPanel from './FiltersPanel'
import {jobRequestAC} from '../../../../redux/jobRequests/jobRequests.duck'
import {
  select_gridSession_show_filters,
} from 'redux/jobRequests/selectors'
import 'components/common/grid/grid.scss'
import {select_router_params} from 'redux/router/selectors'
import {select_auth_user} from 'redux/auth/selectors'

const GridControl: FC = () => {
  const dispatch = useAppDispatch()
  const {isAdmin, isPowerUser} = useSelector(select_auth_user)
  const showFilters = useSelector(select_gridSession_show_filters)
  const {category} = useSelector(select_router_params)
  const filtersShowClass = 'onex-btn--icon onex-btn--filled onex-btn--default'
  const filtersHideClass = filtersShowClass + ' onex-btn--indicator onex-btn--indicator--unread'
  const filtersButtonClass = !showFilters && category
    ? filtersHideClass
    : filtersShowClass
  const toggleFilters = () => {
    dispatch(jobRequestAC.showFiltersToggled())
  }

  const handleOpenDataLoadRequestForm = () => {
    dispatch(jobRequestAC.dataLoadTopicReset())
    dispatch(jobRequestAC.showDetails())
    dispatch(jobRequestAC.showDataLoadRequestFormOpen())
    dispatch(jobRequestAC.fetchJobStatusRequestDetailsOK(null))
  }

  return (
    <>
      <div className='onex-data-grid-control'>
        <div className='onex-data-grid-control__actions'>
          <Stack className='buttons-panel' direction='horizontal' gap={2}>
            {(isAdmin || isPowerUser) &&
              <Button
                dataTestId='new-data-load-request-button'
                onClick={handleOpenDataLoadRequestForm}
              >
            New Job Request
              </Button>
            }
            <Button
              dataTestId='filters-toggle-button'
              onClick={toggleFilters}
              className={filtersButtonClass}
              variant='secondary'
            >
              <Icon>filter_alt</Icon>
              <Icon>{showFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
            </Button>
          </Stack>
        </div>
      </div>
      {showFilters && <FiltersPanel />}
    </>
  )
}

export default GridControl
